import styled from "styled-components";

const View = styled.div`
  width: 100%;
  min-width: 1000px;
  position: absolute;
  user-select: none;
  top: 0;
  background-color: #fff;

  & > div.content {
    position: relative;
    display: block;
    margin: 0 auto;
    width: 1000px;
    height: 60px;
    line-height: 60px;
    vertical-align: middle;

    * {
      display: inline-block;
    }

    & > a {
      height: 100%;

      img {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 20px;
        cursor: pointer;
      }
    }


    & > div {
      float: right;
      font-size: 14px;

      .login {
        margin-right: 16px;

        span:nth-child(1) {
          color: #c79342;
          margin-right: 6px;
        }

        span:nth-child(2) {
          color: #666666;
          cursor: pointer;
        }
      }

      .noLogin {
        margin-right: 16px;

        span {
          color: #ff5900;
          cursor: pointer;
        }
      }

      & > div {
        line-height: 14px;
        padding: 4px 10px;
        color: #fff;
        border-radius: 12px;
        background-color: #c79342;
        cursor: pointer;
        margin-right: 16px;
      }

      label {
        cursor: pointer;

        input {
          vertical-align: middle;
          margin-right: 6px;
          cursor: pointer;
        }
      }
    }
  }
`;


export {
  View
}
